export default "__VITE_ASSET__DYgd0xpw__"